import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import CheckIcon from '@material-ui/icons/Check';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      borderRadius: 99,
      height: function height(_ref) {
        var isMobile = _ref.isMobile;
        return isMobile ? 32 : 50;
      },
      width: function width(_ref2) {
        var isMobile = _ref2.isMobile;
        return isMobile ? 32 : 50;
      },
      display: 'flex',
      zIndex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      backgroundColor: function backgroundColor(_ref3) {
        var active = _ref3.active,
          error = _ref3.error,
          completed = _ref3.completed;
        if (active || completed) {
          return theme.palette.primary.main;
        }
        if (error) {
          return theme.palette.secondary.main;
        }
        return '#fff';
      },
      border: function border(_ref4) {
        var active = _ref4.active,
          error = _ref4.error,
          completed = _ref4.completed;
        if (active || completed) {
          return "1px solid " + theme.palette.primary.main;
        }
        if (!completed || error) {
          return "1px solid " + theme.palette.secondary.main;
        }
        return "1px solid " + theme.palette.grey[400];
      },
      '& svg': {
        color: '#fff'
      }
    },
    text: {
      fontSize: function fontSize(_ref5) {
        var isMobile = _ref5.isMobile;
        return isMobile ? 16 : 22;
      },
      fontWeight: 700,
      color: function color(_ref6) {
        var active = _ref6.active,
          error = _ref6.error,
          completed = _ref6.completed;
        if (!active && !error && !completed) {
          return theme.palette.secondary.main;
        }
        return '#fff';
      }
    }
  };
});
var StepIcon = function StepIcon(_ref7) {
  var active = _ref7.active,
    completed = _ref7.completed,
    error = _ref7.error,
    icon = _ref7.icon;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('sm');
  });
  var classes = useStyles({
    active: active,
    completed: completed,
    error: error,
    isMobile: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, function () {
    if (error) {
      return /*#__PURE__*/React.createElement(Typography, {
        align: "center",
        className: classes.text
      }, "!");
    }
    if (completed && !active) {
      return /*#__PURE__*/React.createElement(CheckIcon, null);
    }
    return /*#__PURE__*/React.createElement(Typography, {
      align: "center",
      className: classes.text
    }, icon);
  }());
};
StepIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool.isRequired,
  /**
   * Mark the step as completed.
   */
  completed: PropTypes.bool.isRequired,
  /**
   * Whether this step has an error.
   */
  error: PropTypes.bool.isRequired,
  /**
   * Which step are we displaying
   */
  icon: PropTypes.node.isRequired
} : {};
export default StepIcon;